export default __webpack_public_path__ + "static/media/builder.c92b1eab.png";